import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import EquityAction from '../views/EquityAction.vue'
import preFilters from "../data/prefilters";

const routes = [
  {
    path: "/",
    name: 'Home',
    redirect: { 
      path: '/1',
    },
  },
  {
    path: '/:page',
    name: 'Page',
    component: Home,
    props: (route) => ({
      prefilterhtml: preFilters,
      ...route.params
    })
  },
  {
    path: '/:page/:prefilter',
    name: 'Prefiltered',
    component: Home,
    props: (route) => ({
      prefilterhtml: preFilters,
      ...route.params
    })
  },
  {
    path: '/action/:id',
    name: 'EquityAction',
    component: EquityAction,
    props: true,
  },
  {
    path: '/action/:id/:name',
    name: 'EquityAction',
    component: EquityAction,
    props: true,
  },
  // {
  //   path: '/action/:id/:name/:page',
  //   name: 'EquityAction',
  //   component: EquityAction,
  //   props: true
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;